import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-10 divide-y divide-gray-200" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "divide-y divide-gray-200" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-6 mt-6 lg:grid-cols-3" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "mt-10 divide-y divide-gray-200" }
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "space-y-5" }
const _hoisted_12 = { class: "grid grid-cols-1 space-y-3 lg:grid-cols-3 lg:space-y-1" }
const _hoisted_13 = { class: "relative flex items-start" }
const _hoisted_14 = { class: "flex items-center h-5" }
const _hoisted_15 = ["id", "name", "value"]
const _hoisted_16 = { class: "ml-3 text-sm" }
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "py-3 mt-10 text-center" }

import {computed, defineComponent, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetProfileRepresentation, GetProfileRepresentationResponse,
    UpdateProfileRepresentation,
} from "@/dtos";
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileRepresentationSettings',
  setup(__props) {

// @ts-ignore
const responseStatus = ref(null);
const profile: Ref<GetProfileRepresentationResponse> = ref(new GetProfileRepresentationResponse());

onMounted(async () => {
    await client.get<GetProfileRepresentationResponse>(new GetProfileRepresentation())
        .then(response => {
            profile.value = response;
        });
});

const isSubmitting = ref(false);
const updateSuccessful= ref(false);
const updateProfileRepresentation = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    let request = profile.value;
    await client.post<ResponseStatus>(new UpdateProfileRepresentation(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "space-y-1" }, [
          _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, "Agent"),
          _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "representedBy"
                }, "Agent Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "representedBy",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profile.value.representedBy) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "representedBy",
                  type: "text"
                }, null, 512), [
                  [_vModelText, profile.value.representedBy]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "representationLocation"
                }, "Agent Location", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "representationLocation",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profile.value.representationLocation) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "representationLocation",
                  type: "text"
                }, null, 512), [
                  [_vModelText, profile.value.representationLocation]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "representationWebsite"
                }, [
                  _createTextVNode("Agent Website "),
                  _createElementVNode("sup", { class: "text-electric-700" }, "PRO")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "representationWebsite",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profile.value.representationWebsite) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "representationWebsite",
                  type: "text"
                }, null, 512), [
                  [_vModelText, profile.value.representationWebsite]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "space-y-1" }, [
          _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, "Union Affiliations (Check all that apply. If non-union, leave blank.)"),
          _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" })
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("fieldset", _hoisted_11, [
              _cache[9] || (_cache[9] = _createElementVNode("legend", { class: "sr-only" }, "Union Affiliations select", -1)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value.unionAffiliationsOptions, (option) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        id: option,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profile.value.unionAffiliations) = $event)),
                        name: option,
                        value: option,
                        "aria-describedby": "",
                        class: "w-4 h-4 border-clay-500 rounded text-powder-600 focus:ring-powder-500",
                        type: "checkbox"
                      }, null, 8, _hoisted_15), [
                        [_vModelCheckbox, profile.value.unionAffiliations]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", {
                        for: option,
                        class: "font-medium text-gray-700"
                      }, _toDisplayString(option), 9, _hoisted_17),
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                    ])
                  ]))
                }), 256))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(SaButton, {
          onClick: _withModifiers(updateProfileRepresentation, ["prevent"]),
          loading: isSubmitting.value,
          variant: "primary"
        }, null, 8, ["loading"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})